// because when js writes something in input field, there is no change event -> this does the change event (bank name)
// @ts-ignore
export function observeElement(
    element: HTMLFormElement,
    property: string,
    callback: any,
    delay = 0,
) {
    // this is used within the codebase to observe changes on element properties
    const elementPrototype = Object.getPrototypeOf(element);
    if (elementPrototype.hasOwnProperty(property)) {
        const descriptor = Object.getOwnPropertyDescriptor(
            elementPrototype,
            property,
        );
        Object.defineProperty(element, property, {
            get: function () {
                // @ts-ignore
                return descriptor?.get?.apply(this, arguments);
            },
            set: function () {
                const oldValue = this[property];
                // @ts-ignore
                descriptor?.set?.apply(this, arguments);
                const newValue = this[property];
                if (typeof callback == "function") {
                    setTimeout(callback.bind(this, oldValue, newValue), delay);
                }
            },
        });
    }
}
